"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReduxSubscription = void 0;
var _react = require("react");
var _configureStore = require("./configureStore");
/**
 * 
 * @param {Function} updateFunction a function telling reactRedux what to do when the state changes.
 */
var useReduxSubscription = function useReduxSubscription(updateFunction) {
  (0, _react.useEffect)(function () {
    var unsubscribe = _configureStore.mainStore.subscribe(function () {
      updateFunction();
    });
    return function () {
      return unsubscribe();
    };
  }, [updateFunction]);
};
exports.useReduxSubscription = useReduxSubscription;